<section class="app_bl">
	<!-- header -->
	<div class="container" id="">
		<header class="page_header">
			<div class="container">
				<div>
					<a routerLink="/dashboard">
						<app-main-logo [imgClasses]="'mt-5'" [imgHeight]="100"></app-main-logo>
					</a>
				</div>
			</div>
		</header>
	</div>
	<!-- /header -->
	<div>
		<div class="">
			<div class="">
				<div class="row justify-content-center">
					<div class="col-lg-6 col-sm-12 col-xs-12 bg-white shadow p-5 mt-5">
						<i id="fly" class="far fa-frown text-light-blue float-right" style="font-size: 68px"></i><br />
						<h1 class="text-blue mb-3">Ooops...Something went wrong.</h1>

						<p class="mt-4">
							{{ errorMessage }}
							<br />
							<span class="text-muted text-sm-80 mt-4">
								Please <a href="mailto:support@zesty.co">contact us</a> at support@zesty.co
							</span>
						</p>
						<p class="mb-0 pt-5 text-center">
							<button class="btn btn-primary" style="max-width: 200px" [routerLink]="settingsRoute">
								Go to Dashboard
							</button>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
